module.exports = __webpack_public_path__ + "static/media/Super-scalper2.0f8db139.PNG";